import React, { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateUserDetailsToStorage } from "../helpers/authHelpers";
import { apiCallWithoutToken } from "../services/v2/apiService";
import * as endPoints from "../constants/v2/endPoints";
import { saveCrossLoginOrigin, isAllowedRedirectUrl } from "../helpers/crossLoginHelper";
import { withBase } from "../helpers/basePath";

const CrossLoginCallback = () => {
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  const token = searchParams.get("token");
  const returnUrl = searchParams.get("returnUrl");

  if (!hasProcessed.current && token) {
    hasProcessed.current = true;

    if (returnUrl) {
      saveCrossLoginOrigin(returnUrl);
    }

    apiCallWithoutToken(endPoints.CROSS_LOGIN_EXCHANGE, "POST", { token })
      .then((response) => {
        const result = response?.result;
        if (!result?.user) {
          redirectBack("Cross-login failed.");
          return;
        }

        // Impersonation detection no longer depends on what's written here
        // (see impersonationHelper.js's isImpersonatedToken) - the access
        // token's own `impersonatedBy` claim is the source of truth, so
        // every cross-login exchange, impersonated or not, tags the same
        // way it always did.
        updateUserDetailsToStorage(
          { result: { user: result.user, userSession: result.userSession, refreshToken: result.refreshToken } },
          "cross-login"
        );

        redirectBack();
      })
      .catch(() => {
        redirectBack("Cross-login failed.");
      });
  }

  if (!token) {
    redirectBack("Missing cross-login token.");
  }

  function redirectBack(errorMessage) {
    if (errorMessage) {
      toast.error(errorMessage);
    }
    const safeUrl =
      returnUrl && isAllowedRedirectUrl(returnUrl) ? returnUrl : withBase("/");
    window.location.href = safeUrl;
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Signing you in...</p>
      </div>
    </div>
  );
};

export default CrossLoginCallback;
